function RequestManager($q) {
	'ngInject';
	let resolve;
	const service = {
		isBlocked,
		wait,
		resolve,
		blockRequests
	};
	let blocked = false;

	return service;

	function isBlocked() {
		return blocked;
	}

	function blockRequests() {
		blocked = true;
	}

	function wait() {
		const deferred = $q.defer();

		resolve = () => {
			blocked = false;
			deferred.resolve();
		};

		return deferred.promise;
	}
}

export default RequestManager;



/** WEBPACK FOOTER **
 ** ./client/components/request-manager/request-manager.service.js
 **/